// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w-WR","type":"styles_type__3QW5M","choices":"styles_choices__24B9C"};